import { render, staticRenderFns } from "./ImportInvoicesDetailsModal.vue?vue&type=template&id=66b6c988"
import script from "./ImportInvoicesDetailsModal.vue?vue&type=script&lang=js"
export * from "./ImportInvoicesDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports